import { render, staticRenderFns } from "./QModal.vue?vue&type=template&id=cc4d411c&scoped=true"
import script from "./QModal.vue?vue&type=script&lang=ts"
export * from "./QModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4d411c",
  null
  
)

export default component.exports